<template>
    <modal-simple :closeBtn="false" :id="id">
        <template v-slot:header>
            <div class="background-standard shadow-standard mt-4" style="height: 60px; width: 100%">
                <img src="@/assets/images/error-icon.png">
            </div>
        </template>
        <template v-slot:content>
            <br>
            <br>
            <h4 class="mb-4">{{ title }}</h4>
            <h5 class="mb-4" v-if="subTitle != ''">{{subTitle}}</h5>

            <button @click="closeModal(id)" class="btn btn-standard-gradient float-right w-25" type="button">Ok</button>
        </template>
    </modal-simple>
</template>

<script>
    import ModalSimple from './modal-simple';

    export default {
        name: 'modal-error',
        components: {ModalSimple},
        props: {
            id: String,
            title: String,
            subTitle: String
        },
        data() {
            return {
                isClosed: false
            };
        },
        created() {
            this.isClosed = false;
        },
        methods: {
            closeModal(id) {
                this.$bvModal.hide(id);
                this.isClosed = true;
                this.$emit('messageFromModal', this.isClosed);
            }
        }
    };
</script>

<style lang="scss" scoped>
    img {
        position: relative;
        top: -15px;
        width: 6rem;
    }

    .voucher-text {
        color: #5a5c61;
    }
</style>
